import styled from "styled-components";
import * as G from "~/components/global.style";

export const CollectionCommandBar  = styled.div`
    height: 45px;
    width: 100%;
    margin-bottom: 40px;
    .ms-SearchBox-field{
        width: 224px;
    }
    .ms-TextField-field
    {
        width: 224px;
    }

    .ms-CommandBar{
       
        .ms-OverflowSet-item{
            background: white;
            button.ms-Button{
                background :white;                
            }
           
            &:not(:last-child) {
             margin-right: 10px;
            }
        }
    }
    .ms-CommandBar{
        background: white;
        padding-left: 8px;
        padding-top: 5px;
      

        .ms-CommandBar-secondaryCommand{
            margin-left: auto;
        }
    }
    .status-New{
        i.ms-Button-icon{
            color: ${G.ColorUnAvailable}
        }
    }
    .status-Working{
        i.ms-Button-icon{
            color: ${G.ColorWaiting}
        }
    }
    .status-Ready{
        i.ms-Button-icon{
            color: ${G.ColorAvailable}
        }
    }
    .status-Discontinued{
        i.ms-Button-icon{
            color: ${G.ColorUnAvailable}
        }
    }
    
`;


// WEBPACK FOOTER //
// ./src/components/collection/collection.styles.ts